import { Link, usePage } from '@inertiajs/react';
import { Heart } from 'lucide-react';
import Logo from '../logo';

const footerLinks = {
  prodotto: [
    { href: '/come-funziona', label: 'Come funziona' },
    { href: '/perche-emovia', label: 'Perché Emovia' },
    { href: '/prezzi', label: 'Prezzi' },
    { href: '/blog', label: 'Blog' },
  ],
  azienda: [
    { href: '/sicurezza', label: 'Sicurezza e Privacy' },
    { href: '/privacy-policy', label: 'Privacy Policy' },
    { href: '/cookie-policy', label: 'Cookie Policy' },
    { href: 'mailto:info@emovia.com', label: 'Contatti' },
  ],
};

export function PublicFooter() {
  const { props } = usePage<{ currentYear?: number }>();
  const currentYear = props.currentYear ?? new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-white">
      <div className="container py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link href="/" className="inline-block mb-4">
              <Logo className="h-8 w-48" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">
              Resta connesso, anche tra le sedute. Emovia è il ponte digitale tra te e i tuoi
              pazienti, per una terapia più consapevole e continua.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Prodotto</h4>
            <ul className="space-y-3">
              {footerLinks.prodotto.map((link) => (
                <li key={link.href}>
                  {link.href.startsWith('mailto:') || link.href.startsWith('/blog') ? (
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Azienda</h4>
            <ul className="space-y-3">
              {footerLinks.azienda.map((link) => (
                <li key={link.href}>
                  {link.href.startsWith('mailto:') || link.href.startsWith('/blog') ? (
                    <a
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Emovia. Tutti i diritti riservati.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Fatto con il <Heart className="h-4 w-4 text-primary fill-primary" aria-hidden /> per gli
            psicologi.
          </p>
        </div>
      </div>
    </footer>
  );
}
